'use strict';

import {ngDepModel} from './ngdepmodel.js';

export class reportItemModel extends ngDepModel
{
		
	constructor(itemData, $filter, jsDataService){
		super(itemData, $filter, jsDataService);
		this.setupItemData(itemData);
	}
	
	
	getValue(name){
		switch(name){
			case 'created':
			case 'updated':
			case 'submission_date':
				if(this[name] == 0){
					return '';
				}
				return this.s('$filter')('u2date')(this[name], 'dd/MM/y HH:mm (Z)');
			case 'starting_date_date':
			case 'end_date_date':
				if(this[name] == 0){
					return '';
				}
				return this[name+'_string'] ? this[name+'_string'] : this.s('$filter')('u2date')(this[name], 'dd/MM/y');
			case 'contract_time':
			case 'contract_sign_time':
			case 'submission_due_date':
			case 'report_date':
			case 'payment_date':
			case 'recovery_decision_date':
			case 'recovery_payment_date':
			case 'report_approval_date':
			case 'date_of_project_end':
				if(this[name] == 0){
					return '';
				}
				return this.s('$filter')('u2date')(this[name], 'dd/MM/y');
			case 'recovery_expiry_date':
				return this.recovery_expiry_date_string;
			case 'a1_general_amount':
			case 'grant_proposed':
			case 'grant_requested':
			case 'maximum_grant_amount':
			case 'max_grant_amount':
			case 'declared_grant_amount':
			case 'accepted_grant_amount':
			case 'ga_amount_to_pay':
			case 'amount_to_pay':
			case 'amount_paid':
			case 'total_paid_amount':
			case 'total_approved_amount':
			case 'approved_amount_to_be_recovered':
			case 'recovery_amount':
			case 'remaining_to_pay':
			case 'remaining_to_be_approved':
			case 'accepted_amount':
			case 'reduction_amount':
			case 'participant_grant_amount':
			case 'rr':
			case 'taap':
			case 'remaining_to_approve':
			case 'recovery_paid_amount':
				return this.s('$filter')('currency')(this[name]);
			case 'percentage_of_approved_amount':
//				return parseFloat(this[name]).toFixed(2)+'%';
				return this.s('$filter')('number')(this[name], 2)+'%';
			case 'completion_percent':
			case 'taap_percent':
				return this.s('$filter')('number')(this[name], 10);
			case 'status':
				return this.getClassifValue(name, 'application_status');
			case 'project_status':
				return this.getClassifValue(name, 'project_status');
			case 'recovery_status':
				return this.getClassifValue(name, 'project_recovery_status');
			case 'contract_status':
				return this.getClassifValue(name, 'contract_status');
			case 'recovery_type':
				return this.getClassifValue(name, 'recovery_type');
			case 'participants_role':
			case 'a3_participants_role':
				return this.getClassifValue(name, 'application_role');
			case 'evaluation_stage':
				return this.getClassifValue(name, 'evaluation_stage');
			case 'a1_general_has_previous':
			case 'initial_payment':
			case 'guarantee_amount_planned':
			case 'recovery_linked_to_irregularity':
				return this.getClassifValue(name, 'yesno');
			case 'admissibility_check_result':
				return this.getClassifValue(name, 'admissibility');
			case 'eligibility_check_result':
				return this.getClassifValue(name, 'eligibility');
			case 'financial_capacity':
				return this.getClassifValue(name, 'financial_capacity');
			case 'payment_type_id':
				return this.getClassifValue(name, 'payment_type');
			case 'report_request_status':
				return this.getClassifValue(name, 'payment_status');
			case 'periodic_report_status':
				return this.getClassifValue(name, 'periodic_report_status');
			case 'report_request_number':
				return this[name];
			case 'coordinator_country_id':
			case 'participants_country_id':
				if(typeof(this[name]) !== 'undefined' && this[name] !== ''){
					return this.getClassifValue(name, 'country');
				}
				break;
//			case 'reporting_dates':
//				return this['periodic_report_dates'];
//			break;
		}
		if(typeof(this[name]) !== 'undefined' && this[name] !== ''){
			return this[name];
		}
		return null;
	}
	
}